<template>
    <v-card>
        <v-card-title>
            {{ $vuetify.lang.t('$vuetify.utc.systemDataCard.systemdata') }}
        </v-card-title>
        <v-data-table
            dense
            :headers="headersUTCDetail"
            :items="utcDataTable()"
            hide-default-header
            hide-default-footer
            mobile-breakpoint="0"
        >
            <template v-slot:[`items.serialnb`]="{ item }">
                <template>
                    <v-icon
                        small
                        class="mr-2"
                        color="black"
                        @click="editItem(item)"
                    >
                        mdi-pencil
                    </v-icon>
                </template>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    export default {
        name: "SystemDataCard",
        data() {
            return {
                headersUTCDetail: [
                    {value: 'key'},
                    {value: 'value'}
                ]
            }
        },
        props: {
            utcInfos: Object,
        },
        methods: {
            utcDataTable() {
                if (this.utcInfos !== undefined) {
                    
                    return [
                        { key: this.$vuetify.lang.t('$vuetify.utc.systemDataCard.serialnumber'), value: this.utcInfos.serialnb },
                        { key: this.$vuetify.lang.t('$vuetify.utc.systemDataCard.category'), value: this.utcInfos.distanceCategory },
                        { key: this.$vuetify.lang.t('$vuetify.utc.systemDataCard.type'), value: this.utcInfos.rangeType },
                        { key: this.$vuetify.lang.t('$vuetify.utc.systemDataCard.hardversion'), value: this.utcInfos.hardVersion }, 
                        { key: this.$vuetify.lang.t('$vuetify.utc.systemDataCard.softversion'), value: this.utcInfos.softVersion },
                        { key: '@ MAC', value: this.utcInfos.mac},
                    ];

                } else {
                    return [];
                }
            },
            convert(val){
                return this.utcInfos.degFormat === 'C' ? val : this.utcInfos.degFormat === 'F' ? (val*9/5)+32 : Number(val)+273.15
            }
        },
    }
</script>



